export const screens = {
  GADGET_PAYMENT: 'GADGET_PAYMENT',
  GADGET_POLICY: 'GADGET_POLICY',
  GADGET_SUMMARY: 'GADGET_SUMMARY',
  ENTER_DETAILS: 'ENTER_DETAILS',
  GADGET_DETAILS: 'GADGET_DETAILS'
}
